import { AbsgArrayHelper } from '@absg/angular-common';
import {
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormControlElementReference } from 'shared.models/form-control-element-reference.model';

@Component({
  selector: '[nc-keypad]',
  templateUrl: './keypad.component.html',
  standalone: false,
})
export class KeypadComponent implements OnInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() isValidValueValidator: (newValue: any) => boolean;

  focusedInput: FormControlElementReference;
  @Input() isDecimalKeyEnabled = true;
  isButtonEnabled = true;

  ngOnInit(): void {
    if (!this.isValidValueValidator) {
      throw new Error('A valid value validator must be provided.');
    }
  }

  // Insert the button value into the previously focused input element
  onKeypadClicked(event: MouseEvent, isBackspace = false): void {
    event.preventDefault();
    const buttonValue: string = (event.target as HTMLElement).textContent;

    if (this.focusedInput) {
      this.focusedInput.elementRef.nativeElement.focus();

      let newValue: string;
      let oldValue: string = this.focusedInput.ngControl.control.value;
      let firstPart: string = oldValue;
      let lastPart = '';
      let isHighlighted = false;
      let newSelectionEnd = 0;
      const selectionStart: number = this.focusedInput.elementRef.nativeElement.selectionStart;
      const selectionEnd: number = this.focusedInput.elementRef.nativeElement.selectionEnd;

      //when all the values within textbox are highlighted then remove everything
      //else if only partial value highlighted within textbox then remove only highlighted value
      if (selectionStart === 0 && selectionEnd === oldValue.length) {
        oldValue = '';
        firstPart = '';
        isHighlighted = true;
      } else if (!AbsgArrayHelper.isNil(selectionStart) && !AbsgArrayHelper.isNil(selectionEnd)
        && selectionStart === selectionEnd && selectionEnd !== oldValue.length) {
        if (isBackspace) {
          firstPart = oldValue.substring(0, selectionStart - 1);
        } else {
          firstPart = oldValue.substring(0, selectionStart);
        }
        lastPart = oldValue.substring(selectionEnd);
        isHighlighted = true;
      } else if ((!AbsgArrayHelper.isNil(selectionStart) && selectionStart !== oldValue.length)
        || (!AbsgArrayHelper.isNil(selectionEnd) && selectionEnd !== oldValue.length)) {
        firstPart = oldValue.substring(0, selectionStart);
        lastPart = oldValue.substring(selectionEnd);
        isHighlighted = true;
      }
      if (isBackspace) {
        //when backspace and text highlited then only remove highlighted text
        // else remove last value
        if (isHighlighted) {
          newValue = firstPart + lastPart;
          newSelectionEnd = firstPart.length;
        } else {
          newValue = oldValue.slice(0, -1);
          newSelectionEnd = newValue.length;
        }
      } else {
        newValue = firstPart + buttonValue + lastPart;
        newSelectionEnd = (firstPart + buttonValue).length;
      }

      if (newValue === '' || isBackspace || this.isValidValueValidator(newValue)) {
        if (!this.focusedInput.ngControl.control.disabled) {
          this.focusedInput.ngControl.control.markAsDirty();
          this.focusedInput.ngControl.control.setValue(newValue);
          this.focusedInput.elementRef.nativeElement.selectionEnd = newSelectionEnd;
        }
      }
    }
  }
}
